import { kvGet } from './idb.js';
import { notify } from './notifications.svelte.js';

const timers = new Map();

export async function initializeCalendarReminders() {
  const events = await kvGet('calendar_events', {});
  scheduleCalendarReminders(events);
}

export function scheduleCalendarReminders(events) {
  for (const timer of timers.values()) clearTimeout(timer);
  timers.clear();
  const now = Date.now();
  for (const [date, dayEvents] of Object.entries(events ?? {})) {
    for (const event of dayEvents) {
      if (!event.reminderMinutes) continue;
      const startsAt = new Date(`${date}T${event.time || '12:00'}`).getTime();
      const delay = startsAt - event.reminderMinutes * 60000 - now;
      if (delay <= 0 || delay >= 2147483647) continue;
      const key = `${date}-${event.id}`;
      timers.set(key, setTimeout(() => {
        notify({
          title: event.title,
          message: `Starts at ${event.time || '12:00'}`,
          icon: 'calendar',
          timeout: 10000,
        });
        timers.delete(key);
      }, delay));
    }
  }
}
